// extracted by mini-css-extract-plugin
export var productImage = "_zs-0";